import { Section } from 'js/new/Components';
import { AppButton } from 'js/new/Components/App';
import App from 'js/new/Layouts/AppLayout';
import { navigate, url } from 'js/services/Network';
import AppUser from 'js/stores/AppUser';
import React, { useState } from 'react';
import * as clipboard from 'clipboard-polyfill';

const Complete = () => {
  const [refLink, setRefLink] = useState('');
  const [clicked, setClicked] = useState(false);

  const redirect = (link, props, params) => navigate(url(link, props, params));

  const copyAndShare = () => {
    const currentLocation = window.location.href;
    const replaceVal = `b/${AppUser.login}`;
    const urlPart = currentLocation.replace('referral/complete', replaceVal);
    const plain = `Hey! I've signed up with PayOnDelivery and got a ₦500 bonus for our transaction. Please use the link below to create the item so we can complete the purchase easily.\nThanks.\n${urlPart}`;

    clipboard.writeText(plain).then(() => {
      setClicked(true)
      setTimeout(() => setClicked(false), 5000)
    });
  };

  React.useEffect(() => {
    if (!AppUser.isLoggedIn) {
      redirect('referral-page');
    } else {
      const userAlias = AppUser.login;
      const currentLocation = window.location.href;
      const urlPart = currentLocation.replace('referral/complete', 'ref');
      setRefLink(`${urlPart}/${userAlias}`);
    }
  }, [AppUser.isLoggedIn]);

  return (
    <App>
      <Section className='tw-grid md:tw-grid-cols-2 tw-py-8 md:tw-py-14'>
        <div className="tw-space-y-4 tw-pt-8 md:tw-pt-14 pb-4 md:tw-pb-12 tw-items-center md:tw-items-start tw-flex tw-flex-col tw-gap-2 md:tw-gap-4 tw-justify-center">
          <div className='tw-rounded-full tw-py-2 tw-px-4 tw-flex tw-items-center border border-gray tw-gap-2'>
            <img src='/images/referrral/psp.png' className='tw-h-10 tw-w-auto' alt='Pay On Delivery' />
            <div>Trusted by 30,000+ people </div>
          </div>
          <h1 className='tw-text-center md:tw-text-left'>You're All Set</h1>
          <p className='tw-text-center md:tw-text-left'>Share this link with your seller to start your first transaction and use your ₦500 credit</p>

          <AppButton
            onClick={copyAndShare}>
            {clicked ? 'Link Copied!' : 'Copy and Share Link'}
          </AppButton>
        </div>

        <div>
          <img src='/images/referrral/celestial-blue.png' className='tw-w-full tw-h-full tw-hidden md:tw-block' alt='Pay On Delivery' />
          <img src='/images/referrral/blue-mobile.png' className='tw-w-full tw-h-auto tw-block md:tw-hidden' alt='Pay On Delivery' />
        </div>
      </Section>

      <div style={{
        backgroundImage: 'url(/images/referrral/bg9.png)',
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center',
        height: window.innerWidth <= 768 ? 300 : 480,
      }}></div>
    </App>
  );
};

export default Complete;
